export default "__VITE_ASSET__B266gcEg__"